/* eslint 'no-useless-constructor': 'off' */
import React, { Component } from 'react';
import { Col, Button, FormGroup } from 'reactstrap';
import {connect} from "react-redux";
import '../../../../../Assets/EnsembleStyles/ChangeLimits.css';

 class DeleteConfirmation extends Component {
    constructor(props){
        super(props);
    }

    render(getLabels) {
        var	Delete	=	this.props.Delete;
        let label = this.props.getLabels;
        return (
            <div className="delete_confirmation_Modal">
                <h4 id="title_Delete" className="Modal_form_title">{this.props.parentToChildData[0]}</h4>
                <div id="txt_Delete_UAText" className="delete_msg_content">
                    {this.props.parentToChildData[1]}
                </div>
                <FormGroup row style={{"padding-top":"15px"}}>
                    <Col sm={{ size: 12 }}>
                        <Button id="btn_NoDelete" className="btn-gray btn-md ChangeLimits_Cancelbtn"  onClick={() => Delete('Cancel')}>{label['TenantConsumption.No.Text'] !== undefined ? label['TenantConsumption.No.Text'] : "No"}</Button>
                        <Button id="btn_YesDelete" className="btn-success btn-md ChangeLimits_Applybtn" onClick={() => Delete('yes')}> {label['TenantConsumption.Yes.Text'] !== undefined ? label['TenantConsumption.Yes.Text'] : "Yes, Delete"} </Button>
                    </Col>
                </FormGroup>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return{
        getLabels : state.CulturalLabelsRootReducer.LabelsBasedOnPreference
    };
};
export default connect(mapStateToProps,null)(DeleteConfirmation);

